import { render } from "./BasePageTitle.vue?vue&type=template&id=5da4cfa4&scoped=true"
import script from "./BasePageTitle.vue?vue&type=script&lang=js"
export * from "./BasePageTitle.vue?vue&type=script&lang=js"

import "./BasePageTitle.vue?vue&type=style&index=0&id=5da4cfa4&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da4cfa4"],['__file',"src/components/helpers/BasePageTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5da4cfa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5da4cfa4', __exports__)) {
    console.log('reload')
    api.reload('5da4cfa4', __exports__)
  }
  
  module.hot.accept("./BasePageTitle.vue?vue&type=template&id=5da4cfa4&scoped=true", () => {
    console.log('re-render')
    api.rerender('5da4cfa4', render)
  })

}


export default __exports__